module.exports = __webpack_public_path__ + "img/2.42d7060c.png";